const groupedData = [
  {
    appName: "AIF Internal App",
    versions: [
      {
        version: "V3",
        ragAppName: "ACI_Semantic",
        status: "Completed",
        active: true,
        createdAt: "15/02/2025 02:50:12 PM",
        refreshedAt: "16/02/2025 02:50:12 PM",
      },
      {
        version: "V2",
        ragAppName: "CI_Semantic_02",
        status: "Completed",
        active: false,
        createdAt: "14/02/2025 02:45:12 PM",
        refreshedAt: "16/02/2025 02:45:12 PM",
      },
      {
        version: "V1",
        ragAppName: "CI_Semantic_0.1",
        status: "Completed",
        active: false,
        createdAt: "11/02/2025 02:45:12 PM",
        refreshedAt: "16/02/2025 02:45:12 PM",
      },
    ],
  },
  {
    appName: "rig Tron",
    versions: [
      {
        version: "V2",
        ragAppName: "Eci_new_seman",
        status: "Inprogress",
        active: false,
        createdAt: "10/02/2025 02:45:12 PM",
        refreshedAt: "11/02/2025 02:45:12 PM",
      },
      {
        version: "V1",
        ragAppName: "ci_rpt_2023",
        status: "Completed",
        active: true,
        createdAt: "8/02/2025 02:45:12 PM",
        refreshedAt: "-",
      },
      {
        version: "V3",
        ragAppName: "ci_rpt_2025",
        status: "Completed",
        active: true,
        createdAt: "8/02/2024 02:45:12 PM",
        refreshedAt: "-",
      },
    ], 
  },
  {
    appName: "Indie 4056",
    versions: [
      {
        version: "V1",
        ragAppName: "DCI_2023",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:50:12 PM",
        refreshedAt: "3/02/2025 02:50:12 PM",
      },
      {
        version: "V2",
        ragAppName: "CI_2026",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:45:12 PM",
        refreshedAt: "3/02/2025 02:45:12 PM",
      },
      {
        version: "V3",
        ragAppName: "CI_2027",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:40:12 PM",
        refreshedAt: "3/02/2025 02:40:12 PM",
      },
      {
        version: "V4",
        ragAppName: "CI_2028",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:40:12 PM",
        refreshedAt: "3/02/2025 02:40:12 PM",
      },
      {
        version: "V5",
        ragAppName: "CI_2029",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:40:12 PM",
        refreshedAt: "3/02/2025 02:40:12 PM",
      },
      {
        version: "V6",
        ragAppName: "CI_2030",
        status: "Completed",
        active: true,
        createdAt: "1/02/2025 02:40:12 PM",
        refreshedAt: "3/02/2025 02:40:12 PM",
      },
    ],
  },
]

const realRagTableData = [
  {
    "rag_app_name": "myTestRagApp",
    "version": "v2",
    "servicename": "mytestService",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-26T16:44:01.420Z",
    "rag_app_status": "Failed",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "myTestRagApp",
    "version": "v1",
    "servicename": "mytestService",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-25T11:39:23.097Z",
    "rag_app_status": "Failed",
    "is_active": 0,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "mayur_index_test",
    "version": "v2",
    "servicename": "mayur_index_tes",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-25T06:24:56.310Z",
    "rag_app_status": "Inprogress",
    "is_active": 0,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "Food_rag",
    "version": "v1",
    "servicename": "FoodRag",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-24T10:09:02.223Z",
    "rag_app_status": "Completed",
    "is_active": 1,
    "data_last_refreshed_date_time": "2025-11-25T07:46:39.370Z"
  },
  {
    "rag_app_name": "otherstest",
    "version": "v2",
    "servicename": "test",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-21T12:08:28.427Z",
    "rag_app_status": "Failed",
    "is_active": 0,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "otherstest",
    "version": "v1",
    "servicename": "test",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-21T12:06:20.313Z",
    "rag_app_status": "Inprogress",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "mayr_sharepoint_index",
    "version": "v1",
    "servicename": "mayur_sharepoin",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-07T07:55:09.050Z",
    "rag_app_status": "Completed",
    "is_active": 1,
    "data_last_refreshed_date_time": "2025-11-07T08:13:52.117Z"
  },
  {
    "rag_app_name": "mayur_uni_test",
    "version": "v1",
    "servicename": "mayur_uni_test",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-06T06:00:34.967Z",
    "rag_app_status": "Completed",
    "is_active": 1,
    "data_last_refreshed_date_time": "2025-11-06T08:13:01.107Z"
  },
  {
    "rag_app_name": "assam_test_index",
    "version": "v1",
    "servicename": "assam_test_inde",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-05T14:18:06.043Z",
    "rag_app_status": "Failed",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "nehu_rag_mayur1",
    "version": "v2",
    "servicename": "nehu_rag_mayur1",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-05T11:47:57.660Z",
    "rag_app_status": "Failed",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "nehu_rag_mayur1",
    "version": "v1",
    "servicename": "nehu_rag_mayur1",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-05T11:36:32.830Z",
    "rag_app_status": "Failed",
    "is_active": 0,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "mayur_index_test",
    "version": "v1",
    "servicename": "mayur_index_tes",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-11-05T07:38:08.537Z",
    "rag_app_status": "Completed",
    "is_active": 1,
    "data_last_refreshed_date_time": "2025-11-25T06:44:38.777Z"
  },
  {
    "rag_app_name": "mayur_rag_app3",
    "version": "v1",
    "servicename": "rag_app3",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-10-13T07:47:35.977Z",
    "rag_app_status": "Inprogress",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "mayur_rag2",
    "version": "v1",
    "servicename": "mayur_test2",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-10-10T07:19:43.227Z",
    "rag_app_status": "Inprogress",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  },
  {
    "rag_app_name": "mayur_rag1",
    "version": "v1",
    "servicename": "test_mayur",
    "created_by": "Mayur.Bora@unilever.com",
    "created_date_time": "2025-10-10T07:02:35.437Z",
    "rag_app_status": "Inprogress",
    "is_active": 1,
    "data_last_refreshed_date_time": null
  }
]


export { groupedData, realRagTableData }
